/** 成分等比类：独占整行 */
export function isFullRowAttribute(attr) {
  return Boolean(attr && (Number(attr.mode) === 4 || attr.isComposition));
}

/**
 * 类目属性排版：两列均分；独占行（成分/末行落单）拉满整行。
 * @returns {{ attr: object, fullWidth: boolean }[]}
 */
export function layoutAttributeFields(attrs = []) {
  const result = [];
  let pair = [];

  const flushPair = () => {
    if (!pair.length) return;
    if (pair.length === 1) {
      result.push({ attr: pair[0], fullWidth: true });
    } else {
      pair.forEach((attr) => result.push({ attr, fullWidth: false }));
    }
    pair = [];
  };

  (attrs || []).forEach((attr) => {
    if (isFullRowAttribute(attr)) {
      flushPair(); // 落单的半格先占满整行
      result.push({ attr, fullWidth: true });
      return;
    }
    pair.push(attr);
    if (pair.length === 2) flushPair();
  });
  flushPair();
  return result;
}
